import { formatDateString } from "./formatDateString";

export function formatDate(date: Date): string {
    return formatDateString(date, "MMM d, yyyy");
}
